/**
 * cci-pullback-page.js
 *
 * CCI Pullback strategy:
 *   Long:  CCI was above +150 in last 10 candles → pulled back to 0–100 · 50 SMA rising
 *   Short: CCI was below −150 in last 10 candles → pulled back to −100–0 · 50 SMA falling
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchCciPullbackData } from '../services/server-api';

const TF_LABELS = { daily: 'Daily', fourHour: '4H' };

function renderDetails(entry) {
  const cciVal   = entry.cci != null ? entry.cci.toFixed(1) : '—';
  const slopeArrow = entry.sma50Slope === 'up' ? '↑ rising' : '↓ falling';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">CCI (current)</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>{cciVal}</span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">50 SMA</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
          {entry.sma50 != null ? `$${entry.sma50.toLocaleString(undefined, { maximumFractionDigits: 4 })}` : '—'} {slopeArrow}
        </span>
      </div>
    </>
  );
}

function CciPullbackPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      'CCI Pullback',
        icon:       '📊',
        subtitle:   'CCI excursion beyond ±150 → pullback into 0–±100 zone · 50 SMA slope confirms trend',
        fetchFn:    fetchCciPullbackData,
        timeframes: ['daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default CciPullbackPage;
